<template>
  <div id="app">
    <div class="maingrid">
      <div class="mainheader">
          <Header v-if="!$route.meta.isHolding" /><HeaderHolding v-if="$route.meta.isHolding" />
      </div>
      <div class="maincontent">
        <router-view />
      </div>
      <footer class="mainfooter"><Footer v-if="!$route.meta.isHolding" /><FooterHolding v-if="$route.meta.isHolding" /></footer>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import HeaderHolding from '@/components/headerholding.vue'
import Footer from '@/components/footer.vue'
import FooterHolding from '@/components/footerholding.vue'

export default {
  components: {
    Header,
    HeaderHolding,
    Footer,
    FooterHolding
  }
}
</script>

<style>
@font-face {
  font-family: "nimbus_sans_l";
  src: url("assets/font/NimbusSanL-Reg-webfont.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "nimbus_sans_l";
  src: url("assets/font/NimbusSanL-BolIta-webfont.woff") format("woff");
  font-weight: bold;
  font-style: italic;
}
@font-face {
  font-family: "nimbus_sans_l";
  src: url("assets/font/NimbusSanL-RegIta-webfont.woff") format("woff");
  font-weight: normal;
  font-style: italic;
}
@font-face {
  font-family: "nimbus_sans_l";
  src: url("assets/font/NimbusSanL-Bol-webfont.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}

body {
  background-color: #eee;
}

a {
  color: #5c6d76;
  /*text-decoration: none;*/
}

a:hover {
  /*text-decoration: underline;*/
}

#app {
  font-family: "nimbus_sans_l", sans-serif;
  font-size: 11pt;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #5c6d76;
}

.maingrid {
  display: grid;
  grid-template-columns: 1fr 900px 1fr;
  grid-template-rows: "auto";
  grid-template-areas:
    ". header ." 
    ". contentarea ."
    ". footer .";
  
}

.maincontent {
  grid-area: contentarea;
  min-height: 500px;
  background-color: white;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  padding: 10px;
}

.mainheader {
  grid-area: header;
  background-color: white;
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  padding: 10px;
}

.mainfooter {
  grid-area: footer;
  background-color: white;
  border-bottom: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
}
</style>
